import React from "react";
import Button from "@mui/material/Button";
import HawksbillImg from "../Images/Hawksbill-B.jpg";
import Link from "@mui/material/Link";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#99aab5", // custom primary color
    },
    secondary: {
      main: "#F27920", // custom secondary color
    },
  },
});

export default function Hawksbill() {
  return (
    <div className="p-5 w-full h-full">
      <div>

        <h2 className="text-2xl font-bold text-[#F27920] pb-5">Hawksbill Sea Turtles</h2>

      </div>
      <div className="lg:float-left lg:w-1/3 mb-5 lg:mr-5">
        <img className="rounded-3xl shadow-lg" src={HawksbillImg} alt="" title="" />
      </div>
      <div>

        The endangered hawksbill, a relatively small turtle, has been hunted to the brink of
        extinction for its beautiful shell. Once fairly common in Florida, these turtles now nest
        here only rarely. Hawksbills feed on sponges and other invertebrates and tend to nest on
        small isolated beaches.

      </div>
      <div className="my-5 text-right mt-20">
        <ThemeProvider theme={theme}>
          <Button color="secondary" variant="contained" >
            <Link href="/SeaTurtles/Hawksbill" title="Hawksbill Sea Turtles" style={{ color: '#ffffff' }}>

              More about Hawksbill Sea Turtles
            </Link>
          </Button>

        </ThemeProvider>
      </div>
    </div >
  );
}
